import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Button, Card } from "react-bootstrap";
import AdminSidebar from "../AdminSidebar";
import { IoMdAddCircle } from "react-icons/io";
import Select from "react-select";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import axios from 'axios';
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Fill } from "react-icons/ri";
import ConfirmDialog from "../../components/ToastNotification/ConfirmModal";
import { useRef } from "react";
import { MdUpload } from "react-icons/md";
const PincodeMaster = () => {
  const fileInputRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [getService, setGetService] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [fetchPincode, setFetchPincode] = useState([]);
  const [formData, setFormData] = useState({
    pincode: '',
    city: ''
  });
  const [file, setFile] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null
  });
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = async e => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    setFile(selectedFile);
    await handleBulkUpload(selectedFile);
    e.target.value = null;
  };
  const showConfirmDialog = ({
    title,
    message,
    onConfirm
  }) => {
    setConfirmDialog({
      show: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog({
          ...confirmDialog,
          show: false
        });
      }
    });
  };
  const handleInputChange = e => {
    const {
      name,
      value,
      files
    } = e.target;
    if (name === "image") {
      setFormData({
        ...formData,
        [name]: files[0]
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  const handleCancel = () => {
    setShowForm(false);
    setIsEditMode(false);
    resetForm();
  };
  const handleEdit = async form => {
    setIsEditMode(true);
    setFormData({
      id: form.id,
      city: form.city || "",
      pinocde: form.pincode || ""
    });
    setEditingCompanyId(form.id);
    setShowForm(true);
  };
  const handleDelete = async id => {
    try {
      await axios.delete(`https://api.sweepydo.in/delete-master-pincode/${id}`);
      showToast("City and pincode deleted successfully", 'success');
      fecthMasterPincode();
    } catch (err) {
      console.error("Error deleting role:", err);
      showToast("Failed to delete city and pincode", 'danger');
    }
  };
  const handleSubmit = async e => {
    e.preventDefault();
    const isDuplicate = fetchPincode?.some(item => item.pincode === formData.pincode);
    if (isDuplicate) {
      showToast('Pincode already exists!', 'warning');
      return;
    }
    try {
      const res = await axios.post("https://api.sweepydo.in/add-master-pincode", {
        pincode: formData.pincode,
        city: formData.city
      });
      fecthMasterPincode();
      setShowForm(false);
      setFormData({
        pincode: '',
        city: ""
      });
      showToast('Pincode And City Added successfully!', 'success');
    } catch (err) {
      const message = err.response?.data?.message;
      if (message === "Pincode already exists") {
        showToast('Pincode already exists!', 'warning');
      } else {
        showToast('Fail to add pincode and city!', 'danger');
      }
      console.error("❌ Error:", message || err.message);
    }
  };
  const handleBulkUpload = async selectedFile => {
    try {
      if (!selectedFile) {
        showToast("Please upload a valid Excel file", "danger");
        return;
      }
      const formData = new FormData();
      formData.append("data_type", "pending");
      formData.append("file", selectedFile);
      const response = await axios.post("https://api.sweepydo.in/upload-bulk-pincode-data", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      showToast("Data submitted successfully!", "success");
      setFile(null);
      fecthMasterPincode();
      // window.location.reload();
    } catch (err) {
      console.error("❌ Error submitting form:", err.response?.data || err.message);
      showToast("Failed to submit data!", "danger");
    }
  };
  useEffect(() => {
    fecthMasterPincode();
  }, []);
  const fecthMasterPincode = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-master-pincode");
      setFetchPincode(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const resetForm = () => {
    setFormData({
      pincode: '',
      city: ''
    });
  };
  const filteredData = Array.isArray(fetchPincode) ? fetchPincode.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  return <div className="container-fluid mt-2" style={{
    minHeight: "100vh"
  }}>
          <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />
      <h2 className="heading mb-4">Pincode Master</h2>

      



 {showForm && <Card className="Card" style={{
      background: "var(--black)",
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "12px",
      boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
      marginBottom: "20px"
    }}>
          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-md-4">
                <label>City</label>
                <input type="text" name="city" value={formData.city} onChange={handleInputChange} className="form-control" required />
              </div>

              <div className="col-md-4">
                <label>Pincode</label>
                <input type="text" name="pincode" value={formData.pincode} onChange={handleInputChange} className="form-control" required />
              </div>

            </div>

            <div className="d-flex justify-content-end">
              
              <Button type="submit" variant="success">
                {isEditMode ? "Update" : "Save"}
              </Button>

              <Button variant="danger" onClick={handleCancel} className="ms-2">
                Cancel
              </Button>
            </div>
          </form>

        </Card>}

  <div className="mb-3" style={{
      background: "var(--black)",
      borderRadius: "12px",
      padding: "15px"
    }}>
   <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
      
          
              <input type="text" className="form-control" style={{
          maxWidth: "300px"
        }} placeholder="Search pincode..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

             <div className="d-flex jsutify-conetnt-end gap-2">

    <Button variant="info" onClick={handleButtonClick} className="text-white">
  <MdUpload size={20} /> Upload Pincode
</Button>

<input type="file" ref={fileInputRef} onChange={handleFileChange} accept=".xlsx,.xls" style={{
            display: "none"
          }} />
      
              <Button variant="primary" onClick={() => {
            setShowForm(true);
          }}>
                <IoMdAddCircle /> Add
              </Button>

              </div>
            </div>
      
            <div className='table-responsive '>
              <table style={{
          width: "100%",
          borderCollapse: "collapse",
          color: "#fff"
        }}>
                <thead>
                  <tr style={{
              backgroundColor: "var(--black2)"
            }}>
                    <th style={{
                padding: "18px",
                textAlign: "center"
              }}>SN</th>
                    <th style={{
                padding: "18px",
                textAlign: "center"
              }}>City</th>
                    <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Pincode </th>
                  
                    <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Action</th>
                  </tr>
                </thead>
                <tbody>
      
                  {filteredData.map((s, i) => <tr key={s.id} style={{
              backgroundColor: "var(--black)",
              borderBottom: "1px solid rgba(255,255,255,0.06)",
              transition: "0.3s"
            }} onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = "var(--black2)";
            }} onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = "var(--black)";
            }}>
                      <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{i + 1}</td>
                      <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.city} </td>
                      <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.pincode} </td>
                  
                      <td style={{
                padding: "18px",
                textAlign: "center"
              }}>
                        
                        <RiDeleteBin6Fill size={20} cursor='pointer' title="Delete" className="mx-2 text-danger" onClick={() => showConfirmDialog({
                  title: 'Delete pincode',
                  message: `Are you sure you want to delete  this pincode and city ?`,
                  onConfirm: () => handleDelete(s.id)
                })} />
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>

 </div>           
      
            <ConfirmDialog show={confirmDialog.show} title={confirmDialog.title} message={confirmDialog.message} onConfirm={confirmDialog.onConfirm} onCancel={() => setConfirmDialog({
      ...confirmDialog,
      show: false
    })} />
      

    </div>;
};
export default PincodeMaster;
